import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { MatDialog } from '@angular/material';

import { DistributionList } from './distribution-list.model';
import { DistributionListsService } from '../users/distribution-lists.service';
import { AuthService } from '../auth/auth.service';
import { User } from './user.model';
import { FormField } from '../forms/form-field.model';
import { FadeInAnimation } from '../shared/fade-in.animation';
import { ConfirmDialogComponent } from '../shared/confirm-dialog.component';

@Component({
  selector: 'app-distribution-lists',
  templateUrl: './distribution-lists.component.html',
  styleUrls: ['./distribution-lists.component.scss'],
  animations: [FadeInAnimation]
})
export class DistributionListsComponent implements OnInit {
  @Input() userOnly: boolean;
  @Input() workflowId: number;
  @Output() newList = new EventEmitter<null>();
  @Output() editList = new EventEmitter<DistributionList>();
  @Output() selectList = new EventEmitter<DistributionList>();

  count: number = 0;
  currentUser = this.authService.currentUser;
  lists: DistributionList[];
  loading: boolean = true;
  page: number = 1;
  search: string;
  searchField: FormField;
  subscription: Subscription;
  total: number = 0;
  get totalPages(): number {return Math.ceil(+this.total/10)};

  constructor(
    private ngZone: NgZone,
    public dialog: MatDialog,
    private authService: AuthService,
    private distributionListsService: DistributionListsService) { }

  ngOnInit() {
    this.searchField = new FormField();
    this.searchField.id = "search";
    this.searchField.type = "search"
    this.searchField.placeholder = "Search Lists"
    this.searchField.defaultValue = this.search;

    this.loadLists();
  }

  onFilterChange(event) {
    switch (event.field) {
    case "search":
      this.search = event.value;
      break;
    }
    this.loadLists();
  }

  loadPage(page: number) {
    this.page = page;
    this.loadLists();
  }

  loadLists() {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    this.loading = true;
    this.subscription = this.distributionListsService.getLists(
      this.page,
      this.search,
      this.workflowId,
      this.userOnly
    ).subscribe(
      (result) => {
        this.lists = result.lists;
        this.count = result.lists.length;
        this.total = result.total;
        this.loading = false;
      },
      (error) => {
        this.lists = [];
        this.count = 0;
        this.total = 0;
        this.loading = false;
      }
    )
  }

  showDeleteDialog(list) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '240px',
      width: '320px',
      data: {
        action: "Delete",
        message: "Delete the list",
        question: list.name
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result.confirm === true) {
        this.deleteList(list);
      }
    })
  }

  deleteList(list) {
    this.distributionListsService.deleteList(list).subscribe(
      (result) => {
        console.log("List Successfully Deleted");
        this.loadLists();
      },
      (error) => {
        console.log("Failed to Delete List");
      }
    )
  }

  userNames(list: DistributionList): string {
    return list.users.map((u) => u.name != null ? u.name : u.email).join(', ')
  }

}



// WEBPACK FOOTER //
// ./src/app/users/distribution-lists.component.ts